import { SxProps, Theme } from "@mui/material/styles";
import * as Global from "styles/global/global.styles";

export function cardCSS(theme: Theme): SxProps<Theme> {
  return {
    // my: "50px",
    // mx: "15rem",
    px: "4rem",
    py: "20px",
    borderRadius: "30px",
    width: { xs: "200px", md: "500px", lg: "600px" },
  };
}

export function containerCSS(theme: Theme): SxProps<Theme> {
  return {
    backgroundColor: { xs: "#F9F9F9", sm: "transparent" },
    px: { xs: "1rem", sm: "3rem", md: "8rem", lg: "3rem" },
    maxWidth: { xs: "390px", sm: "500px", md: "550px" },
  };
}

export function titleCSS(theme: Theme): SxProps<Theme> {
  return {
    textAlign: "center",
  };
}

export function buttonContainerCSS(theme: Theme): SxProps<Theme> {
  return {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    my: "2rem",
  };
}

export function buttonCSS(theme: Theme, buttonName: string): SxProps<Theme> {
  return {
    width: { xs: "100%", sm: "250px", lg: "130px" },
    height: { xs: "50px", lg: "40px" },
    borderRadius: "100px",
    backgroundColor: buttonName === "previous" ? "#006490" : "primary",
  };
}